<template>
  <b-spinner v-if="loading" />
  <NewsPostList
    v-else
    :sectionTitle="sectionTitle"
    :sectionSlug="headingLink ? sectionSlug : null"
    :postList="posts"
    :totalPosts="total"
    :perPage="perPage"
    :headingTag="headingTag"
  />
</template>

<script>
import NewsPostList from "@/components/NewsPostList.vue";

import api from "@/api";

export default {
  name: "PostsSection",
  components: { NewsPostList },
  props: {
    sectionSlug: String,
    perPage: {
      type: Number,
      default: 0
    },
    headingTag: {
      type: String,
      default: "h1"
    },
    errorRedirect: {
      type: Boolean,
      default: true
    },
    headingLink: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      posts: [],
      total: 0,
      sectionTitle: "",
      sectionDescription: null,
      loading: false
    };
  },
  methods: {
    async getPosts(sectionSlug, params) {
      this.loading = true;

      try {
        const { posts, total, section } = await api.getSectionPosts(
          sectionSlug,
          params
        );
        this.posts = posts;
        this.total = total;
        this.sectionTitle = section.title;
        this.sectionDescription = section.description;
      } catch (err) {
        if (this.errorRedirect) {
          this.$router.replace("/error");
        }
      }
      this.loading = false;
    }
  },
  mounted() {
    this.getPosts(this.sectionSlug, { perPage: this.perPage });
  }
};
</script>
